import { GridLegacy as Grid } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';
import {
  StyledStack,
  StyledTwoTitles,
  StyledFirstTitle,
  StyledSecondTitle,
  StyledServiceItem,
  StyledServiceIcon,
  StyledServiceIconWrapper,
  StyledServiceIconBackground,
  StyledServiceTitle,
  StyledServiceDescription,
} from './styles';
import { whyXRPLedgerData } from './WhyXRPLedger.data';
import type { HeroProps } from './WhyXRPLedger.types';

export const WhyXRPLedger = ({ ...props }: HeroProps) => {
  return (
    <Section width="small">
      <StyledStack {...props}>
        <StyledTwoTitles>
          <StyledFirstTitle variant="display_sm">
            {whyXRPLedgerData.mainText}
          </StyledFirstTitle>
          <StyledSecondTitle variant="regular_500">
            {whyXRPLedgerData.description}
          </StyledSecondTitle>
        </StyledTwoTitles>
        <Grid container columnSpacing={{ sm: 8 }} rowSpacing={{ xs: 6, sm: 8 }}>
          {whyXRPLedgerData.services.map((data, index) => (
            <StyledServiceItem key={index} item xs={12} md={6}>
              <div>
                <StyledServiceIconWrapper>
                  <StyledServiceIconBackground>
                    <StyledServiceIcon src={data.img} alt={data.title} />
                  </StyledServiceIconBackground>
                </StyledServiceIconWrapper>
              </div>
              <div>
                <StyledServiceTitle variant="strong_400">
                  {data.title}
                </StyledServiceTitle>
                <br />
                <StyledServiceDescription variant="regular_300">
                  {data.description}
                </StyledServiceDescription>
              </div>
            </StyledServiceItem>
          ))}
        </Grid>
      </StyledStack>
    </Section>
  );
};
